{
  "de": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "Ungespeicherte Änderungen gehen verloren."
        }
      }
    }
  }
}
